import { useSelector } from 'react-redux';
import { toast } from '../../../../../../CommonComponents/OPL/Toast/Toast';
import { MESSAGES } from '../../../../../../CommonConstants';
import { useClientId } from '../../../../../../_hooks/useClientId';
import { useIsCurrentPlanSelected } from '../../../../hooks/useIsCurrentPlanSelected';
import { useFpId } from '../../../../../hooks/useFpId';
import {
  whatIfsBodySelector,
  whatIfsOrDefaultSelector,
} from '../../../../../../WhatIfs/WhatIfsSelector';
import { HEADER_MAP } from './SocialSecurity.meta';
import { useApplySocialSecurityStrategyToPlanMutation } from './api/useApplySocialSecurityStrategyToPlanMutation';
import { SocialSecurityStrategy } from './api/types';

export const useApplySocialSecurityStrategy = () => {
  const clientId = useClientId();
  const fpId = useFpId();
  const { isCurrentPlanSelected } = useIsCurrentPlanSelected();
  const mutation = useApplySocialSecurityStrategyToPlanMutation();
  const whatIfsBody = useSelector(whatIfsBodySelector);
  const isWhatIfsOpen = useSelector(whatIfsOrDefaultSelector).open;
  const isWhatIfsActive = isWhatIfsOpen && whatIfsBody != null;

  const apply = (strategy: SocialSecurityStrategy) => {
    if (mutation.isLoading) {
      return;
    }

    mutation.mutate(
      { clientId, fpId, strategy, ...(isWhatIfsActive ? { body: whatIfsBody } : {}) },
      {
        onSuccess(result) {
          toast.success(result.Message || `${HEADER_MAP('')[strategy]} applied to the plan.`);
        },
        onError(error) {
          toast.error(error instanceof Error ? error.message : MESSAGES.GENERIC_ERROR);
        },
      },
    );
  };

  return {
    apply,
    isUpdatingTable: mutation.isLoading,
    applyingStrategy: mutation.variables?.strategy ?? null,
    isApplyVisible: isCurrentPlanSelected,
  };
};
